<div [ngClass]=AppConfig.theme>
  <nav mat-tab-nav-bar>
    <a mat-tab-link [routerLink]="['/lectures']" [active]="!filter">전체강의</a>
    <a mat-tab-link [routerLink]="['/lectures', { billing: true }]" [active]="filter === 'true'">유료강의</a>
    <a mat-tab-link [routerLink]="['/lectures', { billing: false }]" [active]="filter === 'false'">무료강의</a>
  </nav>
</div>

<div class="flex-container p-4" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start start" fxLayoutWrap="wrap">
  <ng-container *ngFor="let lecture of lectures | async">
    <app-lecture-nav-item fxFlex="25%" fxFlex.sm="50%" class="w-100"[lecture]="lecture" *ngIf="lecture.public"></app-lecture-nav-item>
  </ng-container>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-nav-list/lecture-nav-list.component.html